/**
 * The follow-up dialog for a retry the backend refused because the last
 * attempt is still Pending (`api.overview.retry` returns `canForce`).
 *
 * A Pending attempt is normally still running, so the backend refuses a second
 * one; but attempts do get stuck in Pending (cancellations especially), and
 * then the only way out is a retry with force=true. That is a deliberate
 * second step, not a checkbox on the first dialog.
 *
 * It is opened on the next tick: `useModal` closes the current dialog once its
 * confirm handler settles, which would otherwise close this one too.
 */
export function offerForceRetry(ask, { what, context, message, onConfirm }) {
  setTimeout(() => ask({
    kind: 'danger',
    title: `Retry the ${what} anyway?`,
    context,
    body: message || `The last ${what} attempt is still Pending.`,
    warning: 'Only for an attempt that is stuck. If it is still running, the provider gets the request twice.',
    confirmLabel: 'Retry anyway',
    onConfirm
  }), 0);
}
